import gsap from 'gsap'
import { q1O, s0 } from '../util/nE'
import SplitText from 'gsap/SplitText'
gsap.registerPlugin(SplitText)

class Accordion {
  constructor ($el) {
    this.el = $el
    this.accordionItems = this.el.querySelectorAll('.accordion__item')
    this.sectionTitle = this.el.querySelector('.accordion__section-title')
  }

  init () {
    this.buildTimelineIn()
    this.bindToggle()
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1.2,
      },
      onComplete: () => {
        this.buildHover()
      },
    })

    tl.set(this.el, { autoAlpha: 1 })

    tl.fromTo(this.accordionItems, {
      yPercent: 100,
      autoAlpha: 0,
    }, {
      yPercent: 0,
      autoAlpha: 1,
      stagger: 0.15,
    }, 0)

    if (this.sectionTitle) {
      tl.fromTo(this.sectionTitle, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
      }, 0)
    }
  }

  bindToggle () {
    this.accordionItems.forEach(item => {
      const toggleButton = item.querySelector('.accordion__toggle')
      const content = item.querySelector('.accordion__content')

      toggleButton.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active')

        const currentAnimation = gsap.getTweensOf(content)

        if (currentAnimation.length && currentAnimation[0].isActive()) {
          return
        }

        if (isActive) {
          item.classList.remove('is-active')
          gsap.to(content, {
            height: 0,
            duration: 0.7,
            ease: (t) => {
              return q1O(t)
            },
          })

          // Reset title animation when closing on mobile
          if ('ontouchstart' in window) {
            const titleTimeline = item.titleAnimation
            if (titleTimeline) {
              this.onMouseLeave(titleTimeline)
            }
          }
        } else {
          item.classList.add('is-active')
          gsap.to(content, {
            height: 'auto',
            duration: 0.7,
            ease: (t) => {
              return q1O(t)
            },
          })
        }
      })
    })
  }

  buildHover () {
    this.accordionItems.forEach((el) => {
      const all = el.querySelectorAll('.accordion__title__inner')
      const first = all[0]
      const last = all[1]

      const splitFirst = this.buildSplitText(first)
      const splitLast = this.buildSplitText(last)

      const stag = (40 / splitFirst.chars.length) * 0.025
      const stag1 = (40 / splitFirst.chars.length) * 0.015

      const tl = this.buildTitlesAnimation(splitFirst, splitLast, first, last, stag, stag1)

      // Store the timeline on the element for access in bindToggle
      el.titleAnimation = tl

      const handleMouseEnter = () => {
        this.onMouseEnter(tl)
      }

      const handleMouseLeave = () => {
        if (!el.classList.contains('is-active')) {
          this.onMouseLeave(tl)
        }
      }

      // For mouse devices
      el.addEventListener('mouseenter', handleMouseEnter)
      el.addEventListener('mouseleave', handleMouseLeave)

      // For touch devices
      if ('ontouchstart' in window) {
        el.addEventListener('touchstart', () => {
          if (!el.classList.contains('is-active')) {
            handleMouseEnter()
          }
        }, { passive: true })
      }

      if (el.classList.contains('is-active')) {
        handleMouseEnter()
      }
    })
  }

  buildTitlesAnimation (splitFirst, splitLast, first, last, stag, stag1) {
    const tl = gsap.timeline({
      paused: true,
      defaults: {
        ease: 'none',
        duration: 1,
      },
    })

    tl.set(last, { autoAlpha: 1 })
    tl.to(splitFirst.chars, {
      yPercent: -100,
      // autoAlpha: 0,
      stagger: stag,
      rotationX: -90,
    }, 0)
    tl.fromTo(splitLast.chars, {
      yPercent: 100,
      // autoAlpha: 0,
      rotationX: 90,
    }, {
      yPercent: 0,
      // autoAlpha: 1,
      rotationX: 0,
      stagger: stag1,
      color: '#005df8',
    }, 0)

    return tl
  }

  onMouseEnter (tl) {
    gsap.to(tl, {
      time: tl.duration(),
      ease: (t) => {
        return q1O(t)
      },
      duration: 1.3,
      overwrite: true,
    })
  }

  onMouseLeave (tl) {
    gsap.to(tl, {
      time: 0,
      duration: 0.7,
      ease: (t) => {
        return s0(t)
      },
      overwrite: true,
    })
  }

  buildSplitText (el) {
    if (!el) {
      return
    }
    const split = new SplitText(el, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      lineThreshold: 10,
    })

    return split
  }

  destroy () {
  }
}

export default Accordion



//////////////////
// WEBPACK FOOTER
// ./scripts/components/Accordion.js
// module id = 23
// module chunks = 0